module.exports = "/_next/static/pages/about/Fragments/17d19aaac1300ca7a4930e247e77d768.jpg";